/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import {
    UPDATE_WD_COMMANDS,
    UPDATE_SCHEMA,
    UPDATE_PROJECT_SCHEMA,
    UPDATE_PERMISSIONS,
    NEW_UPDATE_PERMISSIONS,
    CONTENT_TYPES,
    SET_USERNAME,
    SET_USERAVATAR,
    SET_IS_FREELANCER,
    SET_RAW_DATA,
    SET_USER_IS_STAFF,
    SET_USER_IS_SUPERUSER,
    SET_USER_ID,
    USER_IS_AUTHENTICATED,
    SET_USER_FULLNAME,
    SET_IS_SERIES,
    SHOW_GANTT_VIEW,
    SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW,
    SIDE_BAR_LEFT_SHOW,
    SIDE_BAR_LEFT_WIDTH,
    SET_TASK_FILTER,
    SET_ENTITY_CONTEXT,
    SET_SELECTED_FILTER_ITEMS,
    SIDE_BAR_RIGHT_QUICK_FILTER_SHOW,
    QUICK_FILTER_APPLY,
    SET_QUICK_FILTER_DATA,
    SET_QUICK_FILTER,
    SET_ENTITY_DISPLAY_NAMES,
    SET_VERSION_REVIEW_ATTACHMENTS,
    SET_SELECTED_MARKER_ID,
    SET_VIDEO_PLAYER_TIME_FORMAT,
    SET_CUSTOM_CONTEXT_MENU_ITEMS,
    SET_IS_DARK,
    FEATURE_FLAGS,
    DETAILVIEW_MODE_SIDEBAR_WIDTH,
    NOTIFICATIONS_COUNTER,
    CLOSE_NOTE_STATUS,
    CAN_DOWNLOAD_VIDEO,
    SITE_PREFERENCES,
} from "./actionTypes";

export function updateWDCommands(wizartDesktopCommands) {
    return {
        type: UPDATE_WD_COMMANDS,
        wizartDesktopCommands: wizartDesktopCommands,
    };
}

export function updateSchema(schema) {
    return {
        type: UPDATE_SCHEMA,
        schema: schema,
    };
}

export function updateProjectSchema(schema) {
    return {
        type: UPDATE_PROJECT_SCHEMA,
        projectSchema: schema,
    };
}

export function updatePermissions(permissions) {
    return {
        type: UPDATE_PERMISSIONS,
        permissions: permissions,
    };
}

export function newUpdatePermissions(permissions) {
    return {
        type: NEW_UPDATE_PERMISSIONS,
        newPermissions: permissions,
    };
}

export function setContentTypes(value) {
    return {
        type: CONTENT_TYPES,
        value: value,
    };
}

export function setUser(data) {
    const getFullname = ({ full_name_, first_name, last_name, username }) => {
        if (full_name_) return full_name_;
        if (first_name && last_name) return `${first_name} ${last_name}`;
        return username;
    };

    return (dispatch) => {
        dispatch(setUsername(data.username));
        dispatch(setUseravatar(data.avatar));
        dispatch(setIsFreelancer(data.is_freelancer));
        dispatch(setUserId(data.id));
        dispatch(setUserIsStaff(data.is_staff));
        dispatch(setUserIsSuperuser(data.is_superuser));
        dispatch(setUserFullname(getFullname(data)));
        dispatch(setCanDownloadVideo(data.can_download_video));
    };
}

export function setUsername(username) {
    return {
        type: SET_USERNAME,
        username: username,
    };
}

export function setUseravatar(useravatar) {
    return {
        type: SET_USERAVATAR,
        useravatar: useravatar,
    };
}

export function setIsFreelancer(is_freelancer) {
    return {
        type: SET_IS_FREELANCER,
        is_freelancer: is_freelancer,
    };
}

export function setRawData(rawData) {
    return {
        type: SET_RAW_DATA,
        rawData: rawData,
    };
}

export const setUserIsStaff = (isStaff) => {
    return {
        type: SET_USER_IS_STAFF,
        isStaff: isStaff,
    };
};

export const setUserIsSuperuser = (isSuperuser) => {
    return {
        type: SET_USER_IS_SUPERUSER,
        isSuperuser: isSuperuser,
    };
};

export const setUserId = (userId) => {
    return {
        type: SET_USER_ID,
        id: userId,
    };
};

export const setUserIsAuthenticated = (authenticatedStatus) => {
    return {
        type: USER_IS_AUTHENTICATED,
        status: authenticatedStatus,
    };
};

export const setUserFullname = (userFullname) => {
    return {
        type: SET_USER_FULLNAME,
        name: userFullname,
    };
};

export const setProjectIsSeries = (isSeries) => {
    return {
        type: SET_IS_SERIES,
        status: isSeries,
    };
};

export const setShowRightSideBarDetailView = (value) => {
    return {
        type: SIDE_BAR_RIGHT_DETAIL_VIEW_SHOW,
        sideBarRightDetailViewShow: value,
    };
};

export const setShowGanttView = (value) => {
    return {
        type: SHOW_GANTT_VIEW,
        showGanttView: value,
    };
};

export const setShowRightSideBarQuickFilter = (value) => {
    return {
        type: SIDE_BAR_RIGHT_QUICK_FILTER_SHOW,
        sideBarRightQuickFilterShow: value,
    };
};

export const setSideBarLeftShow = (value) => {
    return {
        type: SIDE_BAR_LEFT_SHOW,
        sideBarLeftShow: value,
    };
};

export const setSideBarLeftWidth = (value) => {
    return {
        type: SIDE_BAR_LEFT_WIDTH,
        sideBarLeftWidth: value,
    };
};

export const setEntityFilter = (value) => {
    return {
        type: SET_TASK_FILTER,
        entityFilter: value,
    };
};

export const setEntityContext = (value) => {
    return {
        type: SET_ENTITY_CONTEXT,
        entityContext: value,
    };
};

export const setSelectedFilterItems = (value) => {
    return {
        type: SET_SELECTED_FILTER_ITEMS,
        selectedFilterItems: value,
    };
};

export const setQuickFilterApply = (value) => {
    return {
        type: QUICK_FILTER_APPLY,
        quickFilterApply: value,
    };
};

export const setQuickFilterData = (value) => {
    return {
        type: SET_QUICK_FILTER_DATA,
        quickFilterData: value,
    };
};

export const setQuickFilter = (value) => {
    return {
        type: SET_QUICK_FILTER,
        quickFilter: value,
    };
};

export const setEntityDisplayNames = (value) => {
    return {
        type: SET_ENTITY_DISPLAY_NAMES,
        entityDisplayNames: value,
    };
};

export const setVersionReviewAttachments = (value) => {
    return {
        type: SET_VERSION_REVIEW_ATTACHMENTS,
        attachments: value,
    };
};

export const setSelectedMarkerId = (value) => {
    return {
        type: SET_SELECTED_MARKER_ID,
        value,
    };
};

export const setVideoPlayerTimeFormat = (payload) => {
    localStorage.setItem("playerTimeFormat", payload);
    return {
        type: SET_VIDEO_PLAYER_TIME_FORMAT,
        payload,
    };
};

export const setCustomContextMenuItems = (value) => {
    return {
        type: SET_CUSTOM_CONTEXT_MENU_ITEMS,
        customContextMenuItems: value,
    };
};

export const setIsDarkTheme = (isDark) => {
    return {
        type: SET_IS_DARK,
        isDarkTheme: isDark,
    };
};

export const setFeatureFlags = (flag) => {
    return {
        type: FEATURE_FLAGS,
        featureFlags: flag,
    };
};

export const setSitePreferences = (preferences) => {
    return {
        type: SITE_PREFERENCES,
        sitePreferences: preferences,
    };
};

export const setDWModeSidebarWidth = (width) => {
    return {
        type: DETAILVIEW_MODE_SIDEBAR_WIDTH,
        dVModeSidebarWidth: width,
    };
};

export const setNotificationsCounter = (amount) => {
    return {
        type: NOTIFICATIONS_COUNTER,
        notificationsCounter: amount,
    };
};

export const setCloseNoteStatus = (id) => {
    return {
        type: CLOSE_NOTE_STATUS,
        closeNoteStatus: id,
    };
};

export function setCanDownloadVideo(can_download_video) {
    return {
        type: CAN_DOWNLOAD_VIDEO,
        canDownloadVideo: can_download_video,
    };
}
